export default __webpack_public_path__ + "static/usa-0f368fb37248a500291e8c88a6c3532a.svg";